import React from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentCollectionId, selectPage, selectPatternType } from './store/patternManagerSlice';

import BraceletMaker from './components/BraceletMaker';
import CollectionList from './components/CollectionList';
import CollectionDetail from './components/CollectionDetail';
import Home from './components/Home';

const App: React.FC = () => {
  const page = useSelector(selectPage);
  const patternType = useSelector(selectPatternType);
  const currentCollectionId = useSelector(selectCurrentCollectionId);

  if (page === 'new' && patternType) {
    return <BraceletMaker patternType={patternType} isNewPattern={true} />;
  } else if (page === 'edit' && patternType) {
    return <BraceletMaker patternType={patternType} isNewPattern={false} />;
  } else if (page === 'collections') {
    return <CollectionList />;
  } else if (page === 'collection-detail' && currentCollectionId) {
    return <CollectionDetail />;
  } else {
    return <Home />;
  }
}

export default App;
